export function appendSearchParams(urlOrPath: string, searchParams: URLSearchParams) {
  const paramsString = searchParams.toString();
  if (paramsString === "") return urlOrPath;
  return urlOrPath.includes("?") ? urlOrPath + "&" + paramsString : urlOrPath + "?" + paramsString;
}
